<template>
  <v-autocomplete
    ref="bankList"
    :items="searchBank"
    :wait="100"
    :get-label="getLabel"
    :auto-select-one-item="false"
    :component-item="SearchTemplate"
    @update-items="searchInputChange"
    @item-selected="selected"
    @change="inputChange"
    v-model="searchCode"
    placeholder="Search [Bank]"
    title="Search Bank (minimum 3 charater required)"
  ></v-autocomplete>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import Autocomplete from "v-autocomplete";
import SearchTemplate from "./BankSearchTemplate";
import "v-autocomplete/dist/v-autocomplete.css";
import allMasterJS from "../serviceJS/AllMasterJS.js";
vue.use(Autocomplete);
export default {
  name: "BankMasterList",
  components: {},
  model: {
    event: "input",
    event: "change",
  },
  props: {
    value: { default: "" },
  },
  data() {
    return {
      searchCode: this.value,
      searchBank: [],
      selectObj: null,
      SearchTemplate,
    };
  },
  mounted() {
    self = this;
    let _call = this.fetchByInjectValueBank;
    this.$root.$on("callChangeBank", function (x, y) {
      _call(x, y);
    });
  },
  watch: {
    value: function (newValue, oldValue) {},
  },
  methods: {
    getLabel(item) {
      if (item != null) {
        this.$emit("change", item.bankID);
        return item.bankName;
      }
    },
    fetchByInjectValueBank(x, y) {
      let self = this;
      self.searchInputChange(x, y, function (obj) {
        if (obj != null && obj != undefined) {
          self.searchCode = {
            bankID: obj[0].bankID,
            bankName: obj[0].bankName,
          };
        } else {
          self.searchCode = {
            bankID: -1,
            bankName: "",
          };
        }
      });
    },
    searchInputChange(text, id, callback) {
      this.searchBank = [];
      if (text == null) text = "";
      if (text != "") {
        const _data_ = { BankID: -1, type: 1, SearchText: text };
        allMasterJS.GetBankListAutoComplete(_data_).then(
          (response) => {
            if (response.data.length > 0) {
              this.searchBank = response.data;
              if (typeof callback === "function" && id != null) {
                callback(
                  response.data.filter((l) => {
                    return l.bankID == id;
                  })
                );
              }
            }
          },
          (error) => {}
        );
      }
    },
    clickInput: function () {},
    clickButton: function () {
      if (this.selectedObj != null) {
      }
    },
    selected: function (obj) {
      if (obj != null && obj != undefined) {
        this.selectedObj = obj;
      }
    },
    enter: function () {
      if (this.selectedObj != null) {
      }
    },
    keyUp: function () {},
    keyDown: function () {},
    keyRight: function () {},
    clear: function () {},
    escape: function () {},
    inputChange: function (e) {
      if (e.toString().length == 0) {
        this.$emit("reset", "");
      }
    },
  },
};
</script>
<style>
@import url("../../assets/css/Autocomplete.css");
</style>


// WEBPACK FOOTER //
// src/components/usercontrols/BankMasterList.vue